module.exports = __webpack_public_path__ + "img/RegCat-nonmember-v2.469c24cb.svg";